<div>
  <button class="header-btn m-2 add-btn" mat-raised-button (click)="back()">
    <mat-icon>arrow_back</mat-icon> Back
  </button>

  <form [formGroup]="addWebinarForm">
    <div style="background-color: #fff; margin-left: .2rem; border-radius: 10px; padding: 10px;">
      <div class="containerr">
        <div class="dropdown-container" *ngIf=" roleName === 'SUPER_ADMIN'">
          <p class="med-world-basic-font med-world-basic-font__medium secondary_black_color m-0" class="event-title">
            Event Type  <span class="text-danger">*</span> </p>
          <select name="type" class="event-type" [value]="(updateWebinar && eventType === 'cme') ? 'cme' : eventType" formControlName="eventType" title="Select Event Type" #evntType
            (change)="onSelectEventType($event)">
            <option value="webinar" class="option-container">Webinar</option>
            <option value="cme" class="option-container">CME</option>
          </select>
          <mat-error class="error-message error-msg" *ngIf="addWebinarForm.get('eventType')?.hasError('required')"></mat-error>
        </div>
        <div class="col">
          <div style="margin-bottom: 5px;">
            <p class="med-world-basic-font med-world-basic-font__medium secondary_black_color m-0" class="label-styles">
              {{(eventType === 'webinar') ? 'Webinar Title' : (eventType === 'cme') ? 'CME Title' : ''}} <span
                class="text-danger">*</span></p>
          </div>
          <div>
            <mat-form-field appearance="outline" class="input-font  w-100">
              <input matInput formControlName="webinarTitle"
                placeholder="{{(eventType === 'webinar') ? 'Enter Webinar Title' : (eventType === 'cme') ? 'Enter CME Title' : ''}}"
                (input)="capitalizeFirstLetter()" (keydown.enter)="$event.preventDefault()">
              <mat-error class="error-message error-msg" *ngIf="!addWebinarForm.get('webinarTitle')?.valid">
                <img class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg" /> Name is Required
              </mat-error>
            </mat-form-field>
          </div>
        </div>

        <div>
          <div style="margin-bottom: 5px;">
            <p class="med-world-basic-font med-world-basic-font__medium secondary_black_color m-0 "
              class="label-styles">Add Featured Image <span class="text-danger">*</span></p>
          </div>
          <div class="file-container" (dragover)="onDragOver($event)" (drop)="selectFile($event, 'featured', true)"
            [style.border]="addWebinarForm.get('image')?.touched && addWebinarForm.get('image')?.value === '' ? '1px solid red' : ''">
            <label
              class="d-flex justify-content-center  med-world-basic-font med-world-basic-font__medium secondary_black_color text"
              for="upload_featured" mat-raised-button>
              <img alt="" src="./../../assets/images/photo-add.svg"> Drag files here to upload (or) Select Files
              <input type="file" accept=".jpg,.jpeg,.png,.img,.svg,.html,.htm" id="upload_featured"
                style="display: none;" (change)="selectFile($event, 'featured', false)" />
            </label>
          </div>
          <div class="d-flex align-items-center" style="gap: 8px; margin-top: 10px;">
            <div class="d-flex align-items-center">
              <img *ngIf="imageUrl!== ''" style="width:4rem; height: 4rem ;margin-right: 1rem;" alt="image"
                [src]="imageUrl ">
              <mat-error class="error-message error-msg"
                *ngIf="addWebinarForm.get('image')?.touched && !addWebinarForm.get('image')?.valid">
                <img class="error-icon" style="margin-left: 15px;margin-right: 5px;" loading="lazy" alt=""
                  src="./../../assets/images/alert.svg" />Image is Required
              </mat-error>
              <mat-error *ngIf="fileSizeError" class="error-message text-danger">
                File size should not exceed 10MB.
              </mat-error>
              <ng-container>
                <button *ngIf="imageUrl!== ''" mat-icon-button color="warn" (click)="clearSelectedFile('featured')">
                  <mat-icon>close</mat-icon>
                </button>
              </ng-container>
            </div>


          </div>
        </div><br>

        <div>
          <div style="margin-bottom: 5px;">
            <p class="med-world-basic-font med-world-basic-font__medium secondary_black_color m-0 "
              class="label-styles">Speakers Name <span class="text-danger">*</span></p>
          </div>
          <div class="chip-container"
            [style.border]="addWebinarForm.get('speakersName')?.touched && !addWebinarForm.get('speakersName')?.valid ? '1px solid red' : ''">
            <mat-chip-grid #chipGrid1 aria-label="Enter certificate">
              <mat-chip-row class="chip-display" *ngFor="let speaker of speakersName"
                (removed)="removeSpeaker(speaker)">
                {{speaker}}
                <button matChipRemove [attr.aria-label]="'remove ' + speaker">
                  <mat-icon>cancel</mat-icon>
                </button>
              </mat-chip-row>
              <input matInput class="chip-input" placeholder="Enter Speakers Name" [matChipInputFor]="chipGrid1"
                [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur"
                (matChipInputTokenEnd)="addSpeakers($event)" />
            </mat-chip-grid><br>

          </div>
          <mat-error class="error-message error-msg"
            *ngIf="addWebinarForm.get('speakersName')?.touched && !addWebinarForm.get('speakersName')?.valid">
            <img class="error-icon" loading="lazy" style="margin-left: 15px;" alt=""
              src="./../../assets/images/alert.svg" /> Speakers name is Required
          </mat-error>

        </div><br>

        <div class="col">
          <div style="margin-bottom: 5px;">
            <p class="med-world-basic-font med-world-basic-font__medium secondary_black_color m-0 "
              class="label-styles">Organiser Info <span class="text-danger">*</span></p>
          </div>
          <div class="organiser">
            <mat-form-field appearance="outline" class="input-font  w-100">
              <input matInput formControlName="orgName" placeholder="Enter Organiser Name"
                (keydown.enter)="$event.preventDefault()">
              <mat-error class="error-message error-msg" *ngIf="!addWebinarForm.get('orgName')?.valid">
                <img class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg" /> Organiser name is
                Required
              </mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline" class="input-font  w-100">
              <input matInput formControlName="orgEmail" placeholder="Enter Valid Email"
                (keydown.enter)="$event.preventDefault()">
              <mat-error class="error-message error-msg" *ngIf="!addWebinarForm.get('orgEmail')?.valid">
                <img class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg" /> Organiser email
                is Required
              </mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline" class="input-font  w-100">
              <input matInput formControlName="orgPhone" placeholder="Enter Valid Phone Number" type="text" onlyNumbers>
              <mat-error class="error-message error-msg" *ngIf="!addWebinarForm.get('orgPhone')?.valid">
                <img class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg" /> Organiser phone
                is Required
              </mat-error>
            </mat-form-field>
          </div>
        </div>


        <div style="margin-bottom: 5px;">
          <p class="med-world-basic-font med-world-basic-font__medium secondary_black_color m-0 " class="label-styles">
            Speciality <span class="text-danger">*</span></p>
        </div>
        <mat-form-field appearance="outline" class="input-font w-100">
          <input type="text" placeholder="Select Speciality" matInput formControlName="speciality"
            [matAutocomplete]="specialityAuto" required (keydown.enter)="$event.preventDefault()">
          <mat-autocomplete #specialityAuto="matAutocomplete" (optionSelected)="onSpecialitySelected($event)">
            <mat-option *ngFor="let speciality of filteredSpeciality | async" [value]="speciality">
              {{ speciality }}
            </mat-option>
          </mat-autocomplete>
          <mat-error class="error-message error-msg" *ngIf="addWebinarForm.get('speciality')?.hasError('required')">
            <img class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg" /> Speciality is
            Required
          </mat-error>
        </mat-form-field>

        <div>
          <div style="margin-bottom: 5px;">
            <p class="med-world-basic-font med-world-basic-font__medium secondary_black_color m-0 "
              class="label-styles">Add Host Image <span class="text-danger">*</span></p>
          </div>
          <div class="file-container" (dragover)="onDragOver($event)" (drop)="selectFile($event, 'host', true)"
            [style.border]="addWebinarForm.get('hostImage')?.touched && !addWebinarForm.get('hostImage')?.value ? '1px solid red' : ''">
            <label
              class="d-flex justify-content-center  med-world-basic-font med-world-basic-font__medium secondary_black_color text"
              for="upload_host" mat-raised-button>
              <img alt="" src="./../../assets/images/photo-add.svg"> Drag files here to upload (or) Select Files
              <input type="file" accept=".jpg,.jpeg,.png,.img,.svg,.html,.htm" id="upload_host"
                (change)="selectFile($event, 'host', false)" />
            </label>

          </div>
          <div class="d-flex align-items-center" style="gap: 8px; margin-top: 10px;">
            <div class="d-flex align-items-center">
              <img style="width:4rem; height: 4rem ;margin-right: 1rem;" alt="" [src]="hostImageUrl "
                *ngIf="hostImageUrl!==''">
              <ng-container>
                <button mat-icon-button color="warn" (click)="clearSelectedFile('host')" *ngIf="hostImageUrl!==''">
                  <mat-icon>close</mat-icon>
                </button>
              </ng-container>
            </div>
            <mat-error class="error-message error-msg"
              *ngIf="addWebinarForm.get('hostImage')?.touched && !addWebinarForm.get('hostImage')?.valid">
              <img class="error-icon" loading="lazy" style="margin-left: 15px;margin-right: 5px;" alt=""
                src="./../../assets/images/alert.svg" />Host Image is Required
            </mat-error>

          </div>
        </div><br>

        <div style="margin-bottom: 5px;">
          <p class="med-world-basic-font med-world-basic-font__medium secondary_black_color m-0 " class="label-styles">
            {{(eventType === 'webinar') ? 'About Webinar' : (eventType === 'cme') ? 'About CME' : ''}} <span
              class="text-danger">*</span></p>
        </div>
        <div>
          <angular-editor formControlName="aboutWebinar" [config]="config" (blur)="sanitizeContent()"></angular-editor>
          <mat-error class="error-message error-msg"
            *ngIf="addWebinarForm.get('aboutWebinar')?.touched && !addWebinarForm.get('aboutWebinar')?.valid">
            <img class="error-icon" loading="lazy" style="margin-left: 15px;" alt=""
              src="./../../assets/images/alert.svg" /> {{(eventType === 'webinar') ? 'About Webinar' : (eventType ===
            'cme') ? 'About CME' : ''}} is Required
          </mat-error>
        </div><br>

        <div class="dateTime">
          <div class="dateTime-inner">
            <div style="margin-bottom: 5px;">
              <p class="med-world-basic-font med-world-basic-font__medium secondary_black_color m-0"
                class="label-styles">Date</p>
            </div>
            <div>
              <mat-form-field appearance="outline" class="input-font w-100">
                <input matInput [matDatepicker]="datepicker" formControlName="webinarDate" placeholder="mm/dd/yyyy"
                  (keydown.enter)="$event.preventDefault()">
                <mat-datepicker-toggle matIconSuffix [for]="datepicker"></mat-datepicker-toggle>
                <mat-datepicker #datepicker color="primary"></mat-datepicker>
              </mat-form-field>
            </div>
          </div>

          <div class="dateTime-inner">
            <div style="margin-bottom: 5px;">
              <p class="med-world-basic-font med-world-basic-font__medium secondary_black_color m-0"
                style="font-size: 15px;" class="label-styles">Time</p>
            </div>
            <div class="time-input-wrapper">
              <input type="time" class="input-font w-100 timeInpt" formControlName="webinarTime" name="webinarTime"
                [style.color]="addWebinarForm.get('webinarTime')?.value ? 'black!important' : ''"
                [style.border]="addWebinarForm.get('webinarTime')?.touched && !addWebinarForm.get('webinarTime')?.valid ? '1px solid red' : ''"
                style="font-size: 15px;" (keydown.enter)="$event.preventDefault()" />
              <span class="time-placeholder">
                {{ addWebinarForm.get('webinarTime')?.value ? '' : 'HH:MM AM/PM' }}
              </span>
            </div>

            <mat-error class="error-message error-msg error-msg1"
              *ngIf="addWebinarForm.get('webinarTime')?.touched && !addWebinarForm.get('webinarTime')?.valid">
              <img class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg" /> Time is Required
            </mat-error>
          </div>
          <div class="dateTime-inner">
            <div style="margin-bottom: 5px;">
              <p class="med-world-basic-font med-world-basic-font__medium secondary_black_color m-0"
                class="label-styles">Timezone</p>
            </div>

            <mat-form-field appearance="outline" class="input-font w-100">
              <input type="text" matInput placeholder="Select Timezone" formControlName="timezone"
                [matAutocomplete]="autoTimezone" (keyup)="filterTimezones()" [(ngModel)]="searchTimezone"
                (focus)="filterTimezones()" (keydown.enter)="$event.preventDefault()">
              <mat-autocomplete #autoTimezone="matAutocomplete">
                <mat-option *ngFor="let tz of filteredTimezones" [value]="tz">
                  {{ tz }}
                </mat-option>
              </mat-autocomplete>
              <mat-error class="error-message error-msg" *ngIf="!addWebinarForm.get('timezone')?.valid">
                <img class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg" /> Timezone is
                Required
              </mat-error>
            </mat-form-field>
          </div>
        </div>

        <div class="d-flex flex-row ">

          <div class="estduration">
            <div style="margin-bottom: 5px;">
              <p class="med-world-basic-font med-world-basic-font__medium secondary_black_color m-0 "
                class="label-styles">Estimated Duration</p>
              <div class="estduration-inner mt-1">
                <mat-form-field appearance="outline" class="input-font w-100">
                  <input type="text" matInput formControlName="estdH" [matAutocomplete]="autoHour" placeholder="hh"
                    (keydown.enter)="$event.preventDefault()">
                  <mat-autocomplete #autoHour="matAutocomplete">
                    <mat-option *ngFor="let hr of filteredHours | async" [value]="hr">
                      {{ hr }}
                    </mat-option>
                  </mat-autocomplete>
                  <mat-error class="error-message error-msg" *ngIf="addWebinarForm.get('estdH')?.hasError('required')">
                    <img class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg" /> Hour is
                    Required
                  </mat-error>
                </mat-form-field>
              </div>
            </div>

            <div style="margin-bottom: 5px; margin-top: 20px !important;" class=" mt-1 "><br>
              <div class="estduration-inner">
                <mat-form-field appearance="outline" class="input-font w-100">
                  <input type="text" matInput formControlName="estdM" [matAutocomplete]="autoMinute" placeholder="mm"
                    (keydown.enter)="$event.preventDefault()">
                  <mat-autocomplete #autoMinute="matAutocomplete">
                    <mat-option *ngFor="let min of filteredMinutes | async" [value]="min">
                      {{ min }}
                    </mat-option>
                  </mat-autocomplete>
                  <mat-error class="error-message error-msg" *ngIf="addWebinarForm.get('estdM')?.hasError('required')">
                    <img class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg" /> Minute is
                    Required
                  </mat-error>
                </mat-form-field>
              </div>
            </div>

            <div style="margin-bottom: 5px; margin-top: 20px !important;" class=" mt-1 "><br>
              <div class="estduration-inner">
                <mat-form-field appearance="outline" class="input-font w-100">
                  <input type="text" matInput formControlName="estdS" [matAutocomplete]="autoSecond" placeholder="ss"
                    (keydown.enter)="$event.preventDefault()">
                  <mat-autocomplete #autoSecond="matAutocomplete">
                    <mat-option *ngFor="let sec of filteredSeconds | async" [value]="sec">
                      {{ sec }}
                    </mat-option>
                  </mat-autocomplete>
                  <mat-error class="error-message error-msg" *ngIf="addWebinarForm.get('estdS')?.hasError('required')">
                    <img class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg" /> Second is
                    Required
                  </mat-error>
                </mat-form-field>
              </div>
            </div>

            <div class="estduration-inner">
              <div style="margin-bottom: 5px;">
                <p class="med-world-basic-font med-world-basic-font__medium secondary_black_color m-0 mb-1 "
                  class="label-styles">Participants Limit</p>
                <mat-form-field appearance="outline" class="input-font w-100">
                  <input matInput formControlName="participantsLimit" onlyNumbers placeholder="Set Participants Limit">
                  <mat-error class="error-message error-msg"
                    *ngIf="addWebinarForm.get('participantsLimit')?.hasError('required')">
                    <img class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg" /> Hour is
                    Required
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
          </div>

        </div>
        <div class="source">
          <div style="margin-bottom: 5px;">
            <p class="med-world-basic-font med-world-basic-font__medium secondary_black_color m-0" class="label-styles">
              Source
              <span class="text-danger">*</span>
            </p>
          </div>
          <mat-form-field appearance="outline" class="input-font w-100">
            <input type="text" matInput placeholder="Select Source" formControlName="webinarSource"
              [matAutocomplete]="autoSource" (keydown.enter)="$event.preventDefault()">
            <mat-autocomplete #autoSource="matAutocomplete">
              <mat-option *ngFor="let src of filteredSources | async" [value]="src"> {{ src }} </mat-option>
              <mat-option *ngIf="(filteredSources | async)?.length === 0" [disabled]="true"> No results found
              </mat-option>
            </mat-autocomplete>
            <mat-error class="error-message error-msg"
              *ngIf="addWebinarForm.get('webinarSource')?.hasError('required')">
              <img class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg" /> Source is Required
            </mat-error>
          </mat-form-field>
        </div>

        <div class="url">
          <div style="margin-bottom: 5px;">
            <p class="med-world-basic-font med-world-basic-font__medium secondary_black_color m-0" class="label-styles">
              {{ (eventType === 'webinar') ? 'URL' : (eventType === 'cme') ? 'Source URL' : ''}} <span
                class="text-danger">*</span> </p>
          </div>
          <mat-form-field appearance="outline" class="input-font w-100">
            <input matInput formControlName="webinarUrl" placeholder="Enter Valid URL"
              (keydown.enter)="$event.preventDefault()" />
            <mat-error class="error-message error-msg" *ngIf="addWebinarForm.get('webinarUrl')?.hasError('required')">
              <img class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg" /> URL is Required
            </mat-error>
            <mat-error class="error-message error-msg" *ngIf="addWebinarForm.get('webinarUrl')?.hasError('pattern')">
              <img class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg" /> URL must start with
              "https://"
            </mat-error>
          </mat-form-field>
        </div>

        <div *ngIf="updateWebinar && iswebinarActive && (eventType === 'webinar')" class="url">
          <div style="margin-bottom: 5px;">
            <p class="med-world-basic-font med-world-basic-font__medium secondary_black_color m-0" class="label-styles">
              Webinar Recording Link </p>
          </div>
          <mat-form-field appearance="outline" class="input-font w-100">
            <input matInput formControlName="webinarRecordUrl" placeholder="Enter Valid URL"
              (keydown.enter)="$event.preventDefault()" />
            <!-- <mat-error class="error-message error-msg" *ngIf="addWebinarForm.get('webinarRecordUrl')?.hasError('pattern')">
                <img class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg" /> URL must start with "https://"
              </mat-error> -->
          </mat-form-field>
        </div>

        <div *ngIf="eventType === 'cme'" class="url">
          <div style="margin-bottom: 5px;">
            <p class="med-world-basic-font med-world-basic-font__medium secondary_black_color m-0 label-styles">CME Event Type</p>
          </div>

          <div class="d-flex gap-2 mb-2">
            <label>
              <input type="radio" name="isPaid"  (change)="isCmePayable({target: {checked: false}})" [checked]="!isPaid"> Free
            </label>
            <label>
              <input type="radio" name="isPaid" [checked]="isPaid" (change)="isCmePayable($event)"> Paid
            </label>
          </div>
          

          <mat-form-field appearance="outline" class="input-font w-100" *ngIf="isPaid">
            <input matInput type="text" formControlName="amount" (keydown.enter)="$event.preventDefault()" (input)="cmeAmountChange($event)" placeholder="Enter Amount" [value]="webinarAmount" oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1')"/>
             <mat-error class="error-message error-msg" *ngIf="addWebinarForm.get('amount')?.hasError('required')">
              <img class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg" /> Amount is Required
          </mat-error>
          </mat-form-field>
        </div>


        <div class="sponsored" style="margin-left: -8px; margin-top: -5px;" *ngIf=" roleName === 'SUPER_ADMIN'">
          <div style="margin-bottom: 5px; display: flex;">
            <mat-checkbox formControlName="sponsored"
              (change)="addWebinarForm.get('sponsored')?.setValue($event.checked)"></mat-checkbox>
            <p class="med-world-basic-font med-world-basic-font__medium secondary_black_color m-0 is_sponsored">Is
              Sponsored</p>
          </div>
        </div>
        
        <div class="row buttons mt-3 gap-3">
          <button class="button-primary btn btn-primary" type="submit" (click)="saveForm()"> {{ (updateWebinar) ?
            ('update') : 'Save' }} </button>
          <button class="button-inverse btn btn-primary" type="button" (click)="back()">Cancel</button>
        </div>
      </div>
    </div>
  </form>
</div>